import React, { forwardRef, ReactElement, useEffect, useState } from 'react';
import { regexValidation } from '../../../../utils/cob-utils';
import InputZipCode from './components/InputZipCode/InputZipCode';

export interface IZipProps {
    addressType?: string;
    className?: string;
    inputClass?: string;
    id?: string;
    errorText?: string;
    label?:  string | ReactElement | ReactElement[];
    error?: boolean;
    required?: boolean;
    requiredMessage?: string;
    alternate?: boolean;
    maxLength?: number;
    invalidErrorMessage?: string;
    valid?: [boolean, (arg?: any) => void];
    value?: string;
    helperText?: string;
    useSuccessIcon?: boolean;
    showSuccessIcon?: boolean;
    useOutsideValidation?: boolean;
    setValueCallback: THandlerFunction;
    onBlurCallback?: React.FocusEventHandler<HTMLElement>;
    onFocusCallback?: (((value: React.FocusEvent<HTMLInputElement>) => void) & React.FocusEventHandler<any>);
    onKeyDownCallback?: React.KeyboardEventHandler<HTMLElement>;
    disabled?: boolean;
    isPrefill?: boolean;
    removeAsterisk?: boolean;
}

const ZipField = (({    
    value = '',
    className,
    setValueCallback,
    onBlurCallback,
    onFocusCallback,
    onKeyDownCallback,
    useSuccessIcon,
    showSuccessIcon,
    useOutsideValidation,
    valid,
    isPrefill,
    ...rest 
}: IZipProps, ref: React.Ref<any>) => {
    const [showIcon, setShowIcon] = useState(false);
    const [isFieldValid, setIsFieldValid] = useState(false);
    const [isBlurred, setIsBlurred] = useState(false);
    const regex = regexValidation();
    const validity = valid ?? [isFieldValid, setIsFieldValid];

    const validateField = () => {
        value = value ? value.trim(): '';
        if (value === '') {
            return false;
        }
        return value &&
        regex.zip_code.test(value);
    };

    const focusHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.type === 'blur') {
            onBlurCallback && onBlurCallback(e);
        } else if (e.type === 'focus') {
            onFocusCallback && onFocusCallback(e);
        }
        setIsBlurred(e.type !== 'focus');
        handleSuccessIcon(e.type === 'focus');
    };

    const handleSetValue = (e: string) => {
        if (!validity[0]) {
            validity[1](true);
        }

        e = e.replace(/[^0-9]/g, '');

        if (e.length > 5) {
            e = e.slice(0, 5);
        }

        setValueCallback && setValueCallback(e);
    };

    const handleSuccessIcon = (isActive: boolean = false) => {
        const isShowIcon = (useOutsideValidation ?? true) && validateField() && !isActive;
        setShowIcon(isShowIcon);
    };

    useEffect(() => {
        setIsBlurred(true);
    }, []);


    useEffect(() => {
        if (useOutsideValidation === undefined || !isBlurred)
            return;

        handleSuccessIcon();
    }, [value, useOutsideValidation]);

    useEffect(() => {
        if (isPrefill) {
            setShowIcon(false);
        }
    }, [isPrefill]);
    
    return (
        <div className={`ZipCodeField ${className ?? ''}`}>
                <InputZipCode
                {...rest}
                ref={ref}
                value={value}
                setValue={handleSetValue}
                onBlur={focusHandler}
                onFocus={focusHandler}
                onKeyDown={onKeyDownCallback}
                isValid={validateField}
                valid={validity}
                useSuccessIcon={useSuccessIcon}
                showSuccessIcon={showSuccessIcon !== undefined ? showSuccessIcon : showIcon}
                showExclamationError
            />
        </div>
    );
});

export default forwardRef(ZipField);